export type Nullable<T> = T | null;

export type Maybe<T> = T | undefined;

export interface FormatTimeValues {
  hour: string;
  min: string;
  sec: string;
}

export interface Dictionary<T> {
  [key: string]: T;
}

export enum LayoutSize {
  SMALL = 'S',
  DEFAULT = 'D',
}
